import { Component, OnInit, ViewChild, AfterViewInit, ElementRef, OnDestroy } from '@angular/core';
import { MatPaginator, MatSort, MatDialog } from '@angular/material';
import { debounceTime, distinctUntilChanged, tap } from 'rxjs/operators';
import { fromEvent, merge } from 'rxjs';
import { SharedService } from 'src/app/services/sharedService';
import { AtomDataSource } from 'src/app/services/atomTable.datasource';
import { BranchesDialogComponent } from './dialog/branches/branches-dialog.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { BranchesService } from 'src/app/services/branches.service';

@Component({
  selector: 'atom-branches',
  templateUrl: './branches.component.html',
  styleUrls: ['./branches.component.css']
})
export class BranchesComponent implements OnInit, OnDestroy {
  subscriptionUpdateBranch: any;
  subscriptionDeleteBranch: any;
  tabIndex = 0;
  displayedColumns: string[] = ['name', 'activities', 'action'];
  dataSource: AtomDataSource;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('input_search', { static: false }) input: ElementRef;

  constructor(private branchesService: BranchesService, public dialog: MatDialog, public sharedService: SharedService) {
    this.subscriptionUpdateBranch = this.sharedService.updateBranchEmmitter.subscribe(val => {
      if (val) {
        this.branchesService.updateResource('dictionary/branch', val).subscribe(res => {
          this.loacBranchTable();
        })
      }
    })
  
    this.subscriptionDeleteBranch = this.sharedService.deleteBranchEmmitter.subscribe(val => {
      if (val) {
        this.branchesService.deleteResource('dictionary/branch', val).subscribe(res => {
          this.loacBranchTable();
        })
      }
    })
  }

  ngOnInit() {
    this.dataSource = new AtomDataSource(this.branchesService)
  }

  ngAfterViewInit() {

    setTimeout(() => {
      this.dataSource.loadData('dictionary/branch', '', 'asc', 'name', 0, this.paginator.pageSize, {});

    }, 0)

    this.sort.sortChange.subscribe(() => {});

    fromEvent(this.input.nativeElement, 'keyup')
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        tap(() => {
          this.paginator.pageIndex = 0;
          this.loacBranchTable();
        })
      )
      .subscribe();

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loacBranchTable())
      )
      .subscribe();

  }

  loacBranchTable() {
    this.dataSource.loadData('dictionary/branch',
      this.input.nativeElement.value,
      this.sort.direction,
      this.sort.active,
      this.paginator.pageIndex,
      this.paginator.pageSize, {});
  }

  openBranchDialog(branch): void {
    const dialogRef = this.dialog.open(BranchesDialogComponent, {
      width: '550px', panelClass: 'custom-dialog-container',
      data: branch
    });

    dialogRef.afterClosed().subscribe(result => {

    });
  }

  openDeleteDialog(branch): void {
    branch['class'] = 'BRANCH';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '600px', panelClass: 'custom-dialog-container',
      data: {obj:branch, text: 'DIALOG.DELETE_CURRENT_BRANCH', action: 'DELETE' }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  ngOnDestroy() {
    if (this.subscriptionUpdateBranch) this.subscriptionUpdateBranch.unsubscribe();
    if (this.subscriptionDeleteBranch) this.subscriptionDeleteBranch.unsubscribe();
  }

}
